import React from 'react'

import styles from './colorTag.module.scss'

type Props = {
  color: string
  name: string
  className?: string
  defaultName?: string
}

const ColorTag = ({ color, name, className = '', defaultName = 'Default color tag' }: Props) => {
  return (
    <span className={`${styles.spanWrapper} ${className}`}>
      <span className={styles.splotch} style={{ backgroundColor: color }} /> {name || defaultName}
    </span>
  )
}

export default ColorTag
